import { render, staticRenderFns } from "./AutomationTemplateCard.vue?vue&type=template&id=12f10008&scoped=true&"
import script from "./AutomationTemplateCard.vue?vue&type=script&lang=js&"
export * from "./AutomationTemplateCard.vue?vue&type=script&lang=js&"
import style0 from "./AutomationTemplateCard.vue?vue&type=style&index=0&id=12f10008&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f10008",
  null
  
)

export default component.exports